module.exports = __webpack_public_path__ + "img/brandhand-logo.d6904f34.png";